import { ButtonWithLeadingIconXLarge } from "../../DanitComponents/Buttons/ButtonWithLeadingIcon"
import { HorizontalLinkCard } from "../../DanitComponents/Task Cards/HorizontalLinkCard"

const TimesheetScreenTeacherPortal = ({oldTimesheets, month, viewOldTimesheet, startTimesheetProcess}) => {
    return (
        <div className="new-teacher-portal__timesheets">
            <div className='new-teacher-portal__page-label__timesheet'>Timesheets</div>
            <div className='mt-4 w-[80%] mx-auto'>
                <ButtonWithLeadingIconXLarge text={`Generate ${month} Timesheet`} color={'bg-yellow-500'} action={() => startTimesheetProcess()} />
            </div>
            <div className="new-teacher-portal__old-timesheet-wrapper">
                {oldTimesheets.map((timesheet) => 
                    <div key={timesheet.timesheetId} className='my-3'>
                        <HorizontalLinkCard action={() => viewOldTimesheet(timesheet.timesheetId)} name={timesheet.monthYear} badge={{text: timesheet.status.toUpperCase(), color: timesheet.status === 'Approved' ? {background: 'bg-green-200', text: 'text-green-800'} :{background: 'bg-orange-100', text: 'text-orange-800'} }} />
                    </div>
                )}
            </div>
        </div>
    )
}
export default TimesheetScreenTeacherPortal